module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aYq3C"))).then(() => parcelRequire('cvs7o'));